import React from 'react'
import { ReactComponent as RunIcon } from '@/assets/icons/run.svg'
import Button from '@/components/ui/Buttons/Button'
import { Puff } from '@/components/ui/Loaders'
import classes from './RunButton.module.scss'
import clsx from 'clsx'

export type RunButtonProps = {
  onClick: () => void
  isLoading: boolean
}

export const RunButton = ({ onClick, isLoading }: RunButtonProps) => {
  const className = clsx(classes.root, {
    [classes.loading]: isLoading,
  })

  return (
    <Button className={className} color={'primary'} StartIcon={isLoading ? <Puff /> : <RunIcon />} onClick={onClick}>
      {isLoading ? 'Running...' : 'Run'}
    </Button>
  )
}
